<template>
    <v-container row wrap v-if="canShow" style="padding: 0 !important">
        <v-flex xs12 my-3 class="d-flex justify-center" v-if="counter.counterBusiness > 1" style="max-width: 1200px !important">
            Empresa {{ counter.indexCurrent }} de {{ counter.counterBusiness }}
        </v-flex>
        <v-flex xs12 my-3>
            <div class="content__head" style="max-width: 1200px !important">
                <div>
                    <h1>Información socios participantes</h1>
                    <!-- Identificacion de la empresa: sin esto el usuario no sabe de que empresa
                         son los socios que esta viendo y debe retroceder al Paso 1 para averiguarlo. -->
                    <div v-if="nombreEmpresa || rutEmpresa" class="rc-empresa-actual">
                        <strong>{{ nombreEmpresa }}</strong>
                        <span v-if="rutEmpresa"> &middot; {{ rutEmpresa }}</span>
                    </div>
                </div>

                <v-btn style="text-transform: none;" flat  class="btn__mas_tarde" @click="continuarMasTarde">
                    Completar más tarde
                </v-btn>
            </div>
        </v-flex>
        <v-flex class="card__form mb-5" style="max-width: 1200px !important">
            <v-layout column wrap>
                <v-flex mb-3 xs12 class="rc-subtitulo-socios">
                    <span>Actualiza la información de los </span>
                    <span class="rc-tooltip-anchor">
                        <span>beneficiarios finales</span>
                        <v-tooltip top max-width="300">
                            <v-icon slot="activator" size="18" color="var(--theme-primary)" class="rc-tooltip-icon">help_outline</v-icon>
                            <span>Personas naturales que poseen o controlan, directa o indirectamente, al menos el 10% del capital o de los derechos a voto de la empresa.</span>
                        </v-tooltip>
                    </span>
                    <span> y </span>
                    <span class="rc-tooltip-anchor">
                        <span>controladores efectivos</span>
                        <v-tooltip top max-width="300">
                            <v-icon slot="activator" size="18" color="var(--theme-primary)" class="rc-tooltip-icon">help_outline</v-icon>
                            <span>Personas naturales que ejercen el control efectivo sobre las decisiones estratégicas o la administración de la empresa.</span>
                        </v-tooltip>
                    </span>
                    <span> de la empresa</span>
                </v-flex>
                <v-flex mb-2 xs12>
                    <v-btn :disabled="porcentajeGeneral === 0" flat class="full_flat_button"
                    @click="() => { this.resetForm(null); modalHandleAddParticipante = true; }">
                        <v-icon>add</v-icon>  
                        <span class="button-text">Añadir socio participante</span>
                    </v-btn> 
                </v-flex>
                <v-layout class="mb-2" v-if="porcentajeGeneral !== 0">
                    <v-flex xs12>
                        <div class="info__card">
                            <v-icon style="margin-left: 5px;" size="24" color="var(--theme-danger)">info</v-icon>
                            <span class="text__card">
                                El porcentaje de participación de los socios debe sumar 100%
                            </span>
                        </div>
                    </v-flex>
                </v-layout>
                <v-layout v-if="mensajeFaltanCampos" class="mb-2">
                    <v-flex xs12>
                        <div class="info__card">
                            <v-icon style="margin-left: 5px;" size="24" color="var(--theme-danger)">info</v-icon>
                            <span class="text__card">
                                {{ mensajeFaltanCampos }}
                            </span>
                        </div>
                    </v-flex>
                </v-layout>
            </v-layout>
            <v-layout>
                <TableInfo2Vue :columnsWidths="columnWidths" :dataTableInfo="infoTable" :hiddenActions="true" :itemTable="formattedItems" v-on:handleActions="handleFunctionsTable" />
            </v-layout>
            <!-- RC-3727/RC-3728: libro de accionistas (confirmación periódica o onboarding Tradicional).
                 La tarjeta vive dentro del contenido del Step_2 (oculto por v-show cuando no es el paso
                 activo), por eso NO usamos un v-dialog: se portalearía a [data-app] y flotaría sobre
                 otros pasos. El botón "Continuar" deshabilitado (canContinue) comunica el requisito. -->
            <v-layout v-if="mostrarLibro" wrap class="mb-4 mt-3">
                <v-flex xs12>
                    <div class="libro-card">
                        <h3 class="libro-card__title">Documento de libro de accionistas</h3>
                        <p class="libro-card__subtitle">
                            Adjunta el registro de accionistas vigente que respalda la información de los socios participantes:
                        </p>
                        <!-- Input siempre presente (oculto) -->
                        <input
                            ref="libroAccionistasInput"
                            type="file"
                            accept=".pdf,application/pdf"
                            style="display: none;"
                            @change="onLibroFileInput"
                        />
                        <!-- Estado error -->
                        <div v-if="libroError" class="libro-error-card">
                            <div class="libro-error-card__body">
                                <v-icon color="var(--theme-danger)" size="28" style="margin-right: 10px; flex-shrink: 0;">error</v-icon>
                                <div class="libro-file-card__info">
                                    <div class="libro-file-card__name">{{ libroErrorFile ? libroErrorFile.name : '' }}</div>
                                    <div class="libro-file-card__size">{{ libroErrorFile ? formatLibroBytes(libroErrorFile.size) : '' }}</div>
                                </div>
                            </div>
                        </div>
                        <div v-if="libroError" class="libro-error-msg">{{ libroError }}</div>
                        <div v-if="libroError" class="libro-replace-wrap">
                            <v-btn depressed small class="libro-select-otro-btn" @click.stop="triggerLibroPicker">
                                Seleccionar otro archivo
                            </v-btn>
                        </div>
                        <!-- Estado sin archivo: dropzone -->
                        <div
                            v-if="!libro_accionistas_file && !libroError"
                            class="libro-dropzone"
                            :class="{ 'libro-dropzone--dragging': isDraggingLibro }"
                            @click="triggerLibroPicker"
                            @dragenter.prevent="onLibroDragEnter"
                            @dragover.prevent="onLibroDragOver"
                            @dragleave.prevent="onLibroDragLeave"
                            @drop.prevent="onLibroDrop"
                        >
                            <div class="libro-dropzone__hint">Arrastra tu archivo aquí o</div>
                            <svg
                                class="libro-dropzone__icon"
                                xmlns="http://www.w3.org/2000/svg"
                                width="44"
                                height="44"
                                fill="currentColor"
                                viewBox="0 0 16 16"
                                aria-hidden="true"
                            >
                                <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5"/>
                                <path d="M7.646 1.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 2.707V11.5a.5.5 0 0 1-1 0V2.707L5.354 4.854a.5.5 0 1 1-.708-.708z"/>
                            </svg>
                            <a href="javascript:void(0)" class="libro-dropzone__link" @click.stop="triggerLibroPicker">
                                Seleccionar archivo
                            </a>
                            <div class="libro-dropzone__meta">
                                Formato soportado PDF. Peso máximo 10 MB
                            </div>
                        </div>
                        <!-- Estado con archivo: card -->
                        <div v-else-if="libro_accionistas_file" class="libro-file-card">
                            <div class="libro-file-card__body">
                                <svg class="libro-file-card__icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="currentColor" aria-hidden="true">
                                    <path d="M5.5 7a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1zm0 2.5a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1zm0 2.5a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1z"/>
                                    <path d="M9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.5zm0 1v2A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1z"/>
                                </svg>
                                <div class="libro-file-card__info">
                                    <div class="libro-file-card__name" :title="libro_accionistas_file.name">{{ libro_accionistas_file.name }}</div>
                                    <div class="libro-file-card__progress-text" v-if="libroUploading && !libroUploadComplete">
                                        {{ formatLibroBytes(libroUploadedBytes) }} de {{ formatLibroBytes(libro_accionistas_file.size) }}
                                    </div>
                                    <div class="libro-file-card__size" v-else>
                                        {{ formatLibroBytes(libro_accionistas_file.size) }}
                                    </div>
                                </div>
                                <!-- Estado: subiendo -->
                                <span class="libro-file-card__percent" v-if="libroUploading && !libroUploadComplete">{{ libroUploadProgress }}%</span>
                                <!-- Estado: éxito -->
                                <template v-else-if="libroUploadComplete">
                                    <v-icon color="var(--theme-success)" size="22" style="margin-right: 8px;">check_circle</v-icon>
                                    <v-btn flat small class="libro-eliminar-btn" @click.stop="removeLibroFile">
                                        <v-icon size="16" style="margin-right: 4px;">delete</v-icon>
                                        Eliminar
                                    </v-btn>
                                </template>
                                <!-- Estado: sin progreso (fallback) -->
                                <v-btn v-else flat icon small @click.stop="removeLibroFile">
                                    <v-icon size="18">close</v-icon>
                                </v-btn>
                            </div>
                            <!-- Barra de progreso (solo mientras sube) -->
                            <div class="libro-file-card__bar" v-if="libroUploading && !libroUploadComplete">
                                <div class="libro-file-card__bar-fill" :style="{ width: libroUploadProgress + '%' }"></div>
                            </div>
                        </div>
                        <!-- Botón reemplazar (solo en estado éxito) -->
                        <div v-if="libro_accionistas_file && libroUploadComplete" class="libro-replace-wrap">
                            <v-btn flat outline small class="libro-replace-btn" @click.stop="triggerLibroPicker">
                                Reemplazar archivo
                            </v-btn>
                        </div>
                    </div>
                </v-flex>
            </v-layout>
            <v-layout row wrap justify-space-between align-center class="button-container">
                <!-- BTN SUBMIT -->
                <v-flex xs12 sm6 md4 lg3 mb-3 mt-3>
                <v-btn
                    class="rc-button_scol"
                    @click="volver()"
                    :class="smallScreen ? 'small-button' : ''"
                    style="text-transform:none;"
                >
                    <v-icon size="15" color="primary">arrow_back_ios</v-icon>&nbsp;
                    Atrás
                </v-btn>
                </v-flex>
                <v-flex xs12 sm6 md4 lg3 mb-3 mt-3>
                <v-btn
                    :disabled="!canContinue || isLoading"
                    class="rc-button_prim rc-font"
                    @click="validate()"
                    :class="smallScreen ? 'small-button' : ''"
                    style="text-transform:none;"
                >
                    Continuar
                    <v-icon v-if="isLoading" class="spin" right dark>cached</v-icon>
                </v-btn>
                </v-flex>
            </v-layout>
        </v-flex>
        <!-- crear socio participante -->
        <v-dialog v-model="modalHandleAddParticipante" persistent max-width="700">
            <v-card class="text-xs-center pb-2 rc-view" style="position: relative; color: var(--theme-text)">
                <v-btn flat icon class="btn_close" @click="modalHandleAddParticipante = false">
                    <v-icon>close</v-icon>
                </v-btn>
                <v-container class="pb-0">
                    <v-layout row wrap>
                        <v-flex xs12 text-xs-left class="mb-3">
                            <h2 v-if="formHandleParticipante.esCrear  && !formHandleParticipante.empresa_target">Añadir socio participante</h2>
                            <h2 v-else-if="!formHandleParticipante.esCrear">Editar socio participante</h2>
                            <h2 v-if="formHandleParticipante.esCrear && formHandleParticipante.empresa_target">Añadir socio participante de {{ formHandleParticipante.empresa_target }}</h2>
                        </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                        <v-flex xs12 text-xs-left class="mb-3" v-if="formHandleParticipante.esCrear">
                            <h3>Selecciona tipo de participante: </h3>
                            <!-- tipo de participante -->
                            <v-layout row justify-start>
                                <v-flex v-for="(estado, idx) in formHandleParticipante.check_boxes" :key="idx">
                                    <v-checkbox
                                    color="primary"
                                    :label="estado.label"
                                    v-model="estado.checked"
                                    @change="checkTipoParticipante(formHandleParticipante.check_boxes, idx)"
                                    ></v-checkbox>
                                </v-flex>
                            </v-layout>
                        </v-flex>
                    </v-layout>
                    <template v-if="formHandleParticipante.check_boxes[0].checked">
                        <v-form v-model="valid.formCreatePersona" ref="formCreatePersona">
                            <v-layout wrap row >
                                <v-flex xs12 md6 mb-2>
                                    <v-text-field
                                        v-model="formPersona.nombres"
                                        class="rc-creditos__input border-text"
                                        outline
                                        style="padding: 0rem 0.5rem 0rem 0.5rem;"
                                        :rules="reglas.noVacio"
                                        label="Nombres"
                                        >
                                    </v-text-field>
                                </v-flex>
                                <v-flex xs12 md6 mb-2>
                                    <v-text-field
                                        v-model="formPersona.apellidos"
                                        class="rc-creditos__input border-text"
                                        outline
                                        style="padding: 0rem 0.5rem 0rem 0.5rem;"
                                        :rules="reglas.noVacio"
                                        label="Apellidos"
                                        >
                                    </v-text-field>
                                </v-flex>
                                <v-flex xs12 md6 mb-2>
                                    <v-text-field
                                    v-model="formPersona.rut"
                                    class="rc-creditos__input border-text"
                                    outline
                                    style="padding: 0rem 0.5rem 0rem 0.5rem;"
                                    :rules="reglas.rut"
                                    label="RUT"
                                    counter="12"
                                    maxlength="12"
                                    @blur="log(null, formPersona.rut)"
                                    @input="formatterRUT('formPersona', 'rut', formPersona.rut)"
                                    box
                                    >
                                    </v-text-field>
                                </v-flex>
                                <v-flex xs12 md6 mb-2>
                                    <v-text-field
                                        v-model="formPersona.participacion"
                                        class="rc-creditos__input border-text"
                                        outline
                                        style="padding: 0rem 0.5rem 0rem 0.5rem;"
                                        :rules="reglas.percent('Porcentaje de participación', formHandleParticipante.porcentajeMax)"
                                        label="Porcentaje de participación"
                                    >
                                    </v-text-field>
                                </v-flex>
                                <v-flex xs12 md6 mb-2>
                                    <v-combobox
                                    v-model="formPersona.pais"
                                    :items="paises"
                                    class="rc-creditos__input border-text"
                                    outline
                                    style="padding: 0rem 0.5rem 0rem 0.5rem;"
                                    :rules="reglas.validarEstructuraPais"
                                    label="País"
                                    item-text="name"
                                    item-value="id"
                                    >
                                    </v-combobox>
                                </v-flex>
                                <v-flex xs12 md6 mb-2>
                                    <v-text-field
                                        v-model="formPersona.domicilio"
                                        class="rc-creditos__input border-text"
                                        outline
                                        style="padding: 0rem 0.5rem 0rem 0.5rem;"
                                        :rules="reglas.noVacio"
                                        label="Domicilio"
                                    >
                                    </v-text-field>
                                </v-flex>
                                <v-flex xs12 md6 mb-2>
                                    <v-select
                                    v-model="formPersona.pep"
                                    :items="pep_options"
                                    class="rc-creditos__input border-text"
                                    outline
                                    style="padding: 0rem 0.5rem 0rem 0.5rem;"
                                    :rules="reglas.noVacio"
                                    label="Persona expuesta políticamente"
                                    >
                                    </v-select>
                                </v-flex>
                                <v-flex xs12 mb-3>
                                    <div style="display: flex; justify-content: end; align-items: center;">
                                        <v-btn
                                            class="rc-button_prim rc-font"
                                            @click="submitForm('persona')"
                                            style="text-transform:none; max-width: 240px;"
                                            :disabled="!valid.formCreatePersona"
                                            v-if="formHandleParticipante.esCrear"
                                        >
                                            Guardar
                                            <v-icon v-if="isLoading" class="spin" right dark>cached</v-icon>
                                        </v-btn>
                                        <v-btn
                                            class="rc-button_prim rc-font"
                                            @click="submitEdit()"
                                            style="text-transform:none; max-width: 240px;"
                                            :disabled="!valid.formCreatePersona"
                                            v-else
                                        >
                                            Guardar
                                            <v-icon v-if="isLoading" class="spin" right dark>cached</v-icon>
                                        </v-btn>
                                    </div>
                                </v-flex>
                            </v-layout>
                            
                        </v-form>
                    </template>
                    <template v-if="formHandleParticipante.check_boxes[1].checked">
                        <v-form v-model="valid.formCreateEmpresa" ref="formCreateEmpresa">
                            <v-layout wrap row >
                                <v-flex xs12 md12 mb-2>
                                    <v-text-field
                                    v-model="formEmpresa.rut"
                                    class="rc-creditos__input border-text"
                                    outline
                                    style="padding: 0rem 0.5rem 0rem 0.5rem;"
                                    :rules="reglas.rut"
                                    label="RUT"
                                    counter="12"
                                    maxlength="12"
                                    @blur="log(null, formEmpresa.rut)"
                                    @input="formatterRUT('formEmpresa', 'rut', formEmpresa.rut)"
                                    box
                                    >
                                    </v-text-field>
                                </v-flex>
                                <v-flex xs12 md12 mb-2>
                                    <v-text-field
                                        v-model="formEmpresa.razon_social"
                                        class="rc-creditos__input border-text"
                                        outline
                                        style="padding: 0rem 0.5rem 0rem 0.5rem;"
                                        :rules="reglas.noVacio"
                                        label="Razón social"
                                    >
                                    </v-text-field>
                                </v-flex>
                                <v-flex xs12 md6 mb-2>
                                    <v-text-field
                                        v-model="formEmpresa.participacion"
                                        class="rc-creditos__input border-text"
                                        outline
                                        style="padding: 0rem 0.5rem 0rem 0.5rem;"
                                        :rules="reglas.percent('Porcentaje de participación', formHandleParticipante.porcentajeMax)"
                                        label="Porcentaje de participación"
                                    >
                                    </v-text-field>
                                </v-flex>
                                <v-flex xs12 md6 mb-2>
                                    <v-combobox
                                    v-model="formEmpresa.pais"
                                    :items="paises"
                                    class="rc-creditos__input border-text"
                                    outline
                                    style="padding: 0rem 0.5rem 0rem 0.5rem;"
                                    :rules="reglas.validarEstructuraPais"
                                    label="País"
                                    item-text="name"
                                    item-value="id"
                                    >
                                    </v-combobox>
                                </v-flex>
                                <v-flex xs12 mb-3>
                                    <div style="display: flex; justify-content: end; align-items: center;">
                                        <v-btn
                                            class="rc-button_prim rc-font"
                                            @click="submitForm('empresa')"
                                            style="text-transform:none; max-width: 240px;"
                                            v-if="formHandleParticipante.esCrear"
                                            :disabled="!valid.formCreateEmpresa"
                                        >
                                            Guardar
                                            <v-icon v-if="isLoading" class="spin" right dark>cached</v-icon>
                                        </v-btn>
                                        <v-btn
                                            class="rc-button_prim rc-font"
                                            @click="submitEdit()"
                                            style="text-transform:none; max-width: 240px;"
                                            :disabled="!valid.formCreateEmpresa"
                                            v-else
                                        >
                                            Guardar
                                            <v-icon v-if="isLoading" class="spin" right dark>cached</v-icon>
                                        </v-btn>
                                    </div>
                                </v-flex>
                            </v-layout>
                        </v-form>
                    </template>
                </v-container>
            </v-card>
        </v-dialog>
        <v-dialog v-model="modalDeleteParticipante.modal" persistent width="600">
            <v-card class="text-xs-center pa-4 rc-font" style="position: relative; color: var(--theme-text)">
                <div class="text-xs-center">
                    <v-img
                    src="/images/error_modal.png"
                    width="86px"
                    height="86px"
                    style="margin:auto">
                    </v-img>
                    <div v-if="modalDeleteParticipante.isCompany" class="pa-3"><h2>Eliminar empresa o sociedad</h2></div>
                    <div v-else class="pa-3"><h2>Eliminar socio</h2></div>
                    <div class="info-business pb-3">
                        <span style="font-weight:400; font-size: 18px;">¿Estás seguro?</span>
                    </div>
                </div>
                <div class="text-xs-center px-3">
                    <div class="d-flex flex-row justify-center flex-wrap gap-2">
                        <v-btn class="rc-button_scol btn-sm mx-2" style="max-width: 170px; text-transform: none;"
                            @click="modalDeleteParticipante.modal = false"
                        >
                            Cancelar
                        </v-btn>
                        <v-btn @click="eliminarParticipante(modalDeleteParticipante.socio_index)" class="rc-button_prim btn-sm rc-font" style="max-width: 250px; text-transform: none;">
                            Sí, eliminar
                        </v-btn>
                    </div>
                </div>
            </v-card>
        </v-dialog>
    </v-container>
    <v-layout v-else>
        <ShowLoading tituloLoading="Cargando" />
    </v-layout>
    
</template>
<script>
import { Component, Vue } from "vue-property-decorator";
import { RedCapital,  RedCapitalConfig,  SelectedCountry } from "@/configuration";
import { mapState } from "vuex";	
import api from "@/api";
import TableInfo2Vue from "./TableInfo.vue";
import ShowLoading from "@/components/panel/ShowLoading.vue";
import { isRutValid, rutParser } from "@/utils";
import { EventBus } from "@/main";

@Component({
    metaInfo: {
        title: "Evaluación empresa",
        htmlAttrs: {
        // @ts-ignore
        lang: RedCapital[SelectedCountry].Lang,
        },
    },
    props: {
        data_empresa: Object,
        contador_empresa: Object,
        paises_data: Array,
        // RC-3727: modo re-confirmación de socios (empresa Tradicional finalizada). Lo decide el padre.
        confirmacion_mode: { type: Boolean, default: false }
    },
    computed: {
        ...mapState(["setOpenMenuPanel"]),
        setOpenMenuPanel(){
        return this.$store.state.openMenuPanel;
        },
        formattedItems() {
            return this.formatDataToTable(this.socios);
        },
        // RC-3727/3728: mostrar el bloque del libro cuando es re-confirmación (prop) o cuando ya se
        // sabe que la empresa es Tradicional y el compliance no está firmado. Sin polling: reacciona
        // al tipo_empresa del payload o a la clasificación detectada una sola vez en loadInitialData.
        nombreEmpresa() {
            const emp = this.$props.data_empresa && this.$props.data_empresa.empresa;
            if (!emp) return '';
            return emp.razon_social || emp.nombre || '';
        },
        rutEmpresa() {
            const emp = this.$props.data_empresa && this.$props.data_empresa.empresa;
            return (emp && emp.rut) ? emp.rut : '';
        },
        mostrarLibro() {
            if (this.confirmacion_mode) return true;
            // Señal fuerte: Step_6 rebotó por 422 (Tradicional sin libro), aunque no se supiera al montar.
            if (this.$data.forzarLibro) return true;
            const emp = this.$props.data_empresa && this.$props.data_empresa.empresa;
            const statusForm = emp ? parseInt(emp.status_form || 0) : 0;
            if (statusForm === 1) return false;
            const tipo = (emp && emp.tipo_empresa) || this.$data.tipoEmpresaDetectado;
            return tipo === 'Tradicional';
        },
        canContinue() {
            const self = this;
            const sociosOk = this.$data.socios.length > 0 && this.$data.socios.every(function(socio) {
                const socioValido = self.validarSocio(socio);
                const subsociosValidos = socio.socios ? socio.socios.every(function(subSocio) { return self.validarSocio(subSocio); }) : true;
                return socioValido && subsociosValidos && self.porcentajeGeneral === 0;
            });
            if (this.mostrarLibro) {
                return sociosOk && (this.$data.libroUploadComplete || this.$data.libro_accionistas_file instanceof File);
            }
            return sociosOk;
        },
        mensajeFaltanCampos() {
            // Explica por que "Continuar" esta deshabilitado. Cubre dos familias de faltantes:
            //  - socio PERSONA: domicilio / PEP.
            //  - socio EMPRESA: es obligatorio detallar sus socios (validarSocioEmpresa exige
            //    socios.length > 0 y que sumen 100%). Antes este caso deshabilitaba el boton
            //    sin ningun mensaje -> el usuario no sabia que le faltaba.
            // Se recorre en profundidad porque un socio empresa puede tener empresas dentro.
            if (this.canContinue) return null;
            if (!this.$data.socios || this.$data.socios.length === 0) return null;

            const self = this;
            let faltaDomicilio = false;
            let faltaPep = false;
            let empresaSinSocios = null;
            let empresaPorcentaje = null;
            let empresaDatosBase = null;

            const etiquetaEmpresa = function(socio) {
                return (socio && self.evaluarValor(socio.name)) ? socio.name : null;
            };

            const revisarSocio = function(socio) {
                if (!socio) return;

                if (socio.type === 'company') {
                    if (!socio.socios || !Array.isArray(socio.socios) || socio.socios.length === 0) {
                        if (empresaSinSocios === null) empresaSinSocios = etiquetaEmpresa(socio) || '';
                        return;
                    }
                    if (100 - self.calcPorcentaje(socio.socios) !== 0) {
                        if (empresaPorcentaje === null) empresaPorcentaje = etiquetaEmpresa(socio) || '';
                    }
                    if (!self.evaluarValor(socio.name) || !self.evaluarValor(socio.rut) ||
                        !self.evaluarValor(socio.pais) || !self.evaluarValor(socio.participacion)) {
                        if (empresaDatosBase === null) empresaDatosBase = etiquetaEmpresa(socio) || '';
                    }
                    socio.socios.forEach(function(subSocio) { revisarSocio(subSocio); });
                    return;
                }

                if (!self.evaluarValor(socio.domicilio)) faltaDomicilio = true;
                if (!self.evaluarValor(socio.PEP)) faltaPep = true;
            };

            this.$data.socios.forEach(function(socio) { revisarSocio(socio); });

            // Los faltantes del socio empresa se anuncian primero: sin ellos el resto no se puede completar.
            if (empresaSinSocios !== null) {
                return empresaSinSocios
                    ? 'Debes agregar la información de los socios de ' + empresaSinSocios + ' para continuar'
                    : 'Debes agregar la información de los socios de la empresa participante para continuar';
            }
            if (empresaPorcentaje !== null) {
                return empresaPorcentaje
                    ? 'El porcentaje de participación de los socios de ' + empresaPorcentaje + ' debe sumar 100%'
                    : 'El porcentaje de participación de los socios de la empresa participante debe sumar 100%';
            }
            if (empresaDatosBase !== null) {
                return empresaDatosBase
                    ? 'Debes completar los datos de ' + empresaDatosBase + ' para continuar'
                    : 'Debes completar los datos de la empresa participante para continuar';
            }
            if (faltaDomicilio && faltaPep) return 'Debes ingresar domicilio y PEP para continuar';
            if (faltaDomicilio) return 'Debes ingresar domicilio para continuar';
            if (faltaPep) return 'Debes ingresar PEP para continuar';
            return null;
        },
        smallScreen() {
            return this.$vuetify.breakpoint.smAndDown;
        }
    },
    async mounted() {
        //@ts-ignore    
        await this.loadInitialData();
    },
    beforeMount(){
        this.$data.paises = this.$props.paises_data;
        // RC-3728: Step_2 queda montado (v-show) durante todo el flujo. Si Step_6 rebota por 422
        // (Tradicional sin libro), al volver al Paso 2 debe aparecer el dropzone aunque la
        // clasificación no se conociera al montar. Escuchamos la señal y forzamos mostrarLibro.
        EventBus.$on('rc3728-activar-libro', () => { this.$data.forzarLibro = true; });
    },
    beforeDestroy(){
        EventBus.$off('rc3728-activar-libro');
    },
    data() {
        return{
            canShow: false,
            isLoading:false,
            empresa_id: null,
            // RC-3728: forzar mostrar el libro cuando Step_6 rebota por 422 (el cierre confirma que
            // la empresa es Tradicional sin libro, aunque la clasificación no se conociera al montar).
            forzarLibro: false,
            tipoEmpresaDetectado: null,
            libro_accionistas_file: null,
            isDraggingLibro: false,
            libroUploadProgress: 0,
            libroUploading: false,
            libroUploadedBytes: 0,
            libroUploadComplete: false,
            libroError: null,
            libroErrorFile: null,
            counter: {
                counterBusiness: 1,
                indexCurrent: 1,
            },
            socios: [],
            infoTable: {
                headers: [
                    { text: 'Nombre', value: 'name', sortable: false, width: "19%", align: "left"},
                    { text: 'Rut', value: 'rut', sortable: false, width: "14%", align: "left"},
                    { text: 'Participación', value: 'participacion', sortable: false, width: "12%", align: "left"},
                    { text: 'País', value: 'pais' , sortable: false, width: "12%", align: "left"},
                    { text: 'Domicilio', value: 'domicilio', sortable: false, width: "17%", align: "left"},
                    { text: 'PEP', value: 'pep', sortable: false, width: "11%", align: "left"},
                    { text: '', value: 'acciones', sortable: false, width: "15%", align: "left"},
                ],
                msjEmpty: 'No existen registros',
                rowsPerPage: {
                    txt: 'Registro por página',
                    itm: [10, 25, 50, { text: 'Todos', value: -1 }]
                },
            },
            columnWidths: {
                name: '19%',
                rut: '14%',
                participacion: '12%',
                pais: '12%',
                domicilio: '17%',
                pep: '11%',
                acciones: '15%'
            },
            modalHandleAddParticipante: false,
            formHandleParticipante: {
                esCrear: true,
                check_boxes: [
                    {id: 1 , label: 'Persona natural', checked: false },
                    {id: 2, label: 'Empresa o Sociedad', checked: false },
                ],
                empresa_target: null,
                index_target: null,
                porcentajeMax: 100
            },
            formEmpresa: {
                rut: null,
                razon_social: null, 
                participacion:null,
                pais:null,
            },
            formPersona: {
                nombres:null, 
                apellidos:null,
                rut: null, 
                participacion:null,
                pais:null,
                domicilio: null,
                pep: null,
            },
            valid: {
                formCreatePersona: false,
                formCreateEmpresa: false, 
            },
            reglas: {
                noVacio: [
                    // @ts-ignore
                    v => {
                        if(!v || v.trim() === ''){
                            return 'Campo requerido'
                        }else if(v.trim() === '0'){
                            return 'Campo requerido'
                        }else{
                            return true
                        }
                    }
                ],
                rut: [
                    (v) =>
                        !!v || `${RedCapitalConfig(SelectedCountry).DniName} es requerido`,
                    (v) =>
                        isRutValid(v) || `${RedCapitalConfig(SelectedCountry).DniName} inválido`
                ],
                percent: (label, max) => [
                        // @ts-ignore
                    v => {
                        if (!v || v.trim() === '') {
                            return `${label} es requerido`;
                        } else if (v.trim() === '0') {
                            return `${label} es requerido`;
                        } else if (isNaN(v) || v < 0 || v > max) {
                            return `${label} debe ser un número entre 0 y ${max}`;
                        } else {
                            return true;
                        }
                    }
                ],
                validarEstructuraPais: [
                    // @ts-ignore
                    v => {
                        if (!v || v === 0 || v === null || v === undefined) {
                            return 'Campo requerido';
                        }

                        if (typeof v !== 'object' || !v.id || !v.name) {
                            return 'Selecciona un país válido';
                        }

                        return true;
                    }
                ],
            },
            paises: [],
            pep_options: [
                {id: 1, text: 'Si'},
                {id: 2, text: 'No'}
            ],
            modalDeleteParticipante: {
                modal: false,
                isCompany: false,
                socio_index: null,
            },
            porcentajeGeneral: 100,
            isPersonaNatural: false,
        };
    },
    methods: {
        validate() {
            this.$data.isLoading = true;
            //@ts-ignore
            const payload = this.createPayload();

            if (this.confirmacion_mode) {
                // RC-3727: re-confirmar participación de socios + libro de accionistas
                this.$data.libroUploading = true;
                this.$data.libroUploadComplete = false;
                this.$data.libroUploadProgress = 0;
                this.$data.libroUploadedBytes = 0;
                const totalBytes = this.$data.libro_accionistas_file ? this.$data.libro_accionistas_file.size : 0;
                const self = this;
                api.confirmarParticipacionSocios(
                    this.$data.empresa_id,
                    payload.socios,
                    this.$data.libro_accionistas_file,
                    function(percent, loaded) {
                        self.$data.libroUploadProgress = percent;
                        self.$data.libroUploadedBytes = loaded || Math.round((percent / 100) * totalBytes);
                    }
                ).then((resp) => {
                    if (resp && resp.status === 1) {
                        EventBus.$emit('snack-success', resp.message || 'Participación de socios confirmada correctamente.');
                        // Ir a una ruta DISTINTA de la actual (evaluacion-empresa) para no gatillar
                        // NavigationDuplicated (Vue Router 3) ni re-entrar al flujo (loop de re-confirmación).
                        this.$router.push('/panel-facto/estadisticas');
                    } else {
                        EventBus.$emit('snack-error', (resp && resp.message) || 'Ha ocurrido un error, inténtelo más tarde.');
                    }
                }).catch(() => {
                    EventBus.$emit('snack-error', 'Ha ocurrido un error, inténtelo más tarde.');
                }).finally(() => {
                    this.$data.isLoading = false;
                    this.$data.libroUploading = false;
                });
            } else if (this.mostrarLibro && this.$data.libro_accionistas_file instanceof File) {
                // RC-3728: onboarding Tradicional — registrar libro y luego guardar socios y avanzar
                this.$data.libroUploading = true;
                this.$data.libroUploadComplete = false;
                this.$data.libroUploadProgress = 0;
                this.$data.libroUploadedBytes = 0;
                const totalBytesOT = this.$data.libro_accionistas_file ? this.$data.libro_accionistas_file.size : 0;
                const selfOT = this;
                api.registrarLibroAccionistasOnboarding(
                    this.$data.empresa_id,
                    this.$data.libro_accionistas_file,
                    function(percent, loaded) {
                        selfOT.$data.libroUploadProgress = percent;
                        selfOT.$data.libroUploadedBytes = loaded || Math.round((percent / 100) * totalBytesOT);
                    }
                ).then((resp) => {
                    if (resp && resp.status === 1) {
                        this.$data.libroUploadComplete = true;
                        // Continuar al siguiente paso del wizard normalmente
                        api.guardarFormBCI(this.$data.empresa_id, payload).then(() => {
                            this.$emit('changeStep', 2);
                            api.guardarProgreso(this.$data.empresa_id, 3);
                        }).catch(() => {
                            EventBus.$emit('snack-error', 'Ha ocurrido un error al guardar los datos, inténtelo más tarde.');
                        });
                    } else {
                        EventBus.$emit('snack-error', (resp && resp.message) || 'Ha ocurrido un error al subir el libro, inténtelo más tarde.');
                    }
                }).catch(() => {
                    EventBus.$emit('snack-error', 'Ha ocurrido un error, inténtelo más tarde.');
                }).finally(() => {
                    this.$data.isLoading = false;
                    this.$data.libroUploading = false;
                });
            } else {
                // flujo normal (o clasificación aún no conocida → el Paso 6 exige el libro si resulta Tradicional)
                api.guardarFormBCI(this.$data.empresa_id, payload).then((response) => {
                    EventBus.$emit('snack-success', 'Información guardada correctamente');
                    this.$emit('changeStep', 2);
                    //guardar el trackeo
                    api.guardarProgreso(this.$data.empresa_id, 3);
                }).catch(() => {
                    EventBus.$emit('snack-error', 'Ha ocurrido un error, inténtelo más tarde');
                }).finally(() => {
                    this.$data.isLoading = false;
                });
            }
        },
        // RC-3727: dropzone inline para el libro de accionistas
        formatLibroBytes(bytes) {
            if (!bytes) return '0 B';
            const mb = bytes / (1024 * 1024);
            if (mb >= 1) return mb.toFixed(1) + ' MB';
            const kb = bytes / 1024;
            if (kb >= 1) return kb.toFixed(0) + ' KB';
            return bytes + ' B';
        },
        triggerLibroPicker() {
            if (this.$data.isLoading) return;
            const input = this.$refs.libroAccionistasInput;
            if (input) input.click();
        },
        onLibroFileInput(e) {
            const input = e.target;
            if (!input.files || !input.files.length) return;
            this.handleLibroFile(input.files[0]);
            input.value = '';
        },
        onLibroDragEnter() {
            if (this.$data.isLoading) return;
            this.$data.isDraggingLibro = true;
        },
        onLibroDragOver() {
            if (this.$data.isLoading) return;
            this.$data.isDraggingLibro = true;
        },
        onLibroDragLeave() {
            this.$data.isDraggingLibro = false;
        },
        onLibroDrop(e) {
            this.$data.isDraggingLibro = false;
            if (this.$data.isLoading) return;
            const files = e.dataTransfer && e.dataTransfer.files;
            if (!files || !files.length) return;
            this.handleLibroFile(files[0]);
        },
        handleLibroFile(file) {
            const maxBytes = 10 * 1024 * 1024;
            const name = (file.name || '').toLowerCase();
            const okMime = file.type === 'application/pdf';
            const okExt = name.endsWith('.pdf');
            if (!okMime && !okExt) {
                this.$data.libroError = 'Formato no permitido. Solo se acepta PDF.';
                this.$data.libroErrorFile = file;
                this.$data.libro_accionistas_file = null;
                return;
            }
            if (file.size > maxBytes) {
                this.$data.libroError = 'El archivo supera el límite de 10 MB. Inténtalo con una versión comprimida.';
                this.$data.libroErrorFile = file;
                this.$data.libro_accionistas_file = null;
                return;
            }
            this.$data.libroError = null;
            this.$data.libroErrorFile = null;
            this.$data.libro_accionistas_file = file;
            this.iniciarProgresoLibro(file.size);
        },
        iniciarProgresoLibro(totalBytes) {
            this.$data.libroUploading = true;
            this.$data.libroUploadComplete = false;
            this.$data.libroUploadProgress = 0;
            this.$data.libroUploadedBytes = 0;
            const self = this;
            const interval = setInterval(function() {
                if (self.$data.libroUploadProgress >= 100) {
                    self.$data.libroUploadProgress = 100;
                    self.$data.libroUploadedBytes = totalBytes;
                    self.$data.libroUploadComplete = true;
                    clearInterval(interval);
                    return;
                }
                self.$data.libroUploadProgress += 5;
                self.$data.libroUploadedBytes = Math.round((self.$data.libroUploadProgress / 100) * totalBytes);
            }, 40);
        },
        removeLibroFile() {
            this.$data.libro_accionistas_file = null;
            this.$data.libroUploading = false;
            this.$data.libroUploadProgress = 0;
            this.$data.libroUploadedBytes = 0;
            this.$data.libroUploadComplete = false;
            this.$data.libroError = null;
            this.$data.libroErrorFile = null;
        },
        continuarMasTarde(){
            if (this.confirmacion_mode) {
                // RC-3727: en modo confirmación no llamar guardarFormBCI ni guardarProgreso
                // porque guardarProgreso sobrescribe step_form=6 → step_form=2,
                // rompiendo la condición de ServicioVigenciaCompliance.estaVigente()
                this.$router.push({ path: "/panel-facto/estadisticas" });
                return;
            }
            //@ts-ignore
            const payload = this.createPayload();
            const objContMasTarde = {
                show: true, 
                payload,
                empresa_id: this.$data.empresa_id,
                step: 2
            };

            EventBus.$emit("contMasTarde", objContMasTarde);
        },
        async loadInitialData(){
            const { countBusiness, currentBusiness } = this.$props.contador_empresa;
            this.$data.counter.counterBusiness = countBusiness;
            this.$data.counter.indexCurrent = currentBusiness;

            //carga data inicial empresa
            const { empresa:{ id, data_form_guardada, nombre, rut }, personaNatural } = this.$props.data_empresa;
            this.$data.empresa_id = id;
            this.$data.isPersonaNatural = personaNatural;
            // RC-3728: si la clasificación aún no llegó (tipo_empresa null), consultar UNA sola vez el
            // estado para reaccionar sin polling. Si resulta 'Tradicional', mostrarLibro lo reflejará.
            const emp = this.$props.data_empresa && this.$props.data_empresa.empresa;
            const statusForm = emp ? parseInt(emp.status_form || 0) : 0;
            if (!this.confirmacion_mode && emp && !emp.tipo_empresa && statusForm !== 1 && id) {
                try {
                    const resp = await api.getEstadoClasificacion(id);
                    if (resp && resp.status === 1 && resp.data && resp.data.tipo_empresa) {
                        this.$data.tipoEmpresaDetectado = resp.data.tipo_empresa;
                    }
                } catch (e) { /* no bloquear el onboarding si falla la clasificación */ }
            }

            // defensivo: data_form_guardada puede llegar null en modo confirmación
            const data_guardada = (data_form_guardada && data_form_guardada.length) ? JSON.parse(data_form_guardada) : false;
            const socios_track = data_guardada ? data_guardada.find((variable) => variable.slug === 'socios') : false;
            if(socios_track){
                this.handleDataSocios(socios_track);
            }else{
                this.apiCallSocios(personaNatural, { nombre, rut } );
            }

            //@ts-ignore
            this.formatDataToTable(this.$data.socios);
        },
        volver(){
            this.$emit('backStep', 2);
        }, 
        formatDataToTable(array) {
            const propsObjTableAll = {
                style: `text-align: left;
                        font-size: 0.7rem;
                        font-weight: 500;
                        color: var(--theme-text);
                        `
            };
            const propsObjTableButtons = {
                style: `display: flex;
                        justify-content: left;`
            };

            const formatItem = (item, parentIndex = '') => {
                
                const currentIndex = parentIndex ? parentIndex : item.index;
                
                const formattedItem = {
                    name: {
                        value: item.name,
                        props: propsObjTableAll,
                    },
                    rut: {
                        value: item.rut,
                        props: propsObjTableAll,
                    },
                    participacion: {
                        value: item.participacion !== null ? `${item.participacion}%` : '-',
                        props: propsObjTableAll,
                    },
                    pais: {
                        value: item.pais !== null ? item.pais.name : '-',
                        props: propsObjTableAll,
                    },
                    domicilio: {
                        value: item.domicilio !== null ? item.domicilio : '-',
                        props: propsObjTableAll,
                    },
                    pep: {
                        value: item.PEP !== null ? item.PEP : '-',
                        props: propsObjTableAll,
                    },
                    acciones: {
                        value: '',
                        props: propsObjTableButtons,
                        buttons: []
                    },
                };

                if (item.type === 'company') {
                    formattedItem.acciones.buttons = [
                        {
                            funcion: 'addParticipante',
                            icoFont: 'group_add',
                            data: item.index,
                            tooltip: 'Agregar participante',
                            btn_disabled: item.porcentajeGeneral === 0 ? true : false,
                        },
                        {
                            funcion: 'deleteParticipante',
                            icoFont: 'delete',
                            data: item.index,
                            tooltip: 'Eliminar',
                            btn_disabled: false,
                        },
                        {
                            funcion: 'editarParticipante',
                            icoFont: 'border_color',
                            data: item.index,
                            tooltip: 'Editar',
                            btn_disabled: false,
                        },
                        {
                            funcion: 'toggleExpand',
                            icoFont: 'expand_more',
                            data: item.index,
                            tooltip: 'Ver participantes',
                            btn_disabled: false,
                        },
                    ];
                    if (item.socios && item.socios.length > 0) {
                        item.socios.forEach((socio) => { 
                            socio.columns = formatItem(socio, currentIndex);
                            socio.isValid = this.validarSocio(socio);
                        });

                        item.porcentajeGeneral = 100 - this.calcPorcentaje(item.socios)
                    }
                } else if (item.type === 'person') {
                    formattedItem.acciones.buttons = [
                        {
                            funcion: 'editarParticipante',
                            icoFont: 'border_color',
                            data: item.index,
                            tooltip: 'Editar',
                            btn_disabled: false,
                        },
                        {
                            funcion: 'deleteParticipante',
                            icoFont: 'delete',
                            data: item.index,
                            tooltip: 'Eliminar',
                            btn_disabled: false,
                        }
                    ];
                }

                item.parentIndex = currentIndex; 
                return formattedItem;
            };

            array.forEach((item) => {
                item.columns = formatItem(item);
                item.isValid = this.validarSocio(item);
            });

            this.$data.porcentajeGeneral = 100 - this.calcPorcentaje(this.socios);
            return array;

        },
        checkTipoParticipante(checks, indexSeleccionado) {
            //@ts-ignore
            checks.forEach((check, index) => {
                if (index !== indexSeleccionado) {
                    check.checked = false;
                }
            });
        },
        formatterRUT(form, campo, value){
            if(value){
                this.$data[form][campo] = rutParser(value);
            }
        },
        log(el, val) {
            if (isRutValid(val.toUpperCase()) && val.length == 12 && el == '0') {
                EventBus.$emit("snack-success", "Rut válido");
            }
        },
        submitForm(tipo){
            switch (tipo){
                case 'persona': {
                    //@ts-ignore
                    const socio = this.createPersona(this.$data.formPersona);
                    const parentIndexPersona = this.formHandleParticipante.index_target || null;

                    if (this.formHandleParticipante.esCrear && this.validarRutDuplicadoSocio(socio.rut, socio.type, { parentIndex: parentIndexPersona })) {
                        EventBus.$emit('snack-error', 'Ya existe un socio con este RUT');
                        return;
                    }

                    if(this.formHandleParticipante.index_target !== null){
                        this.agregarParticipante(this.formHandleParticipante.index_target, socio);
                    }else{
                        //@ts-ignore
                        this.handleSocios(socio);
                    }
                    this.resetForm('formCreatePersona');
                    break;
                }
                case 'empresa': {
                    //@ts-ignore
                    const new_socio = this.createEmpresa(this.$data.formEmpresa);
                    const parentIndexEmpresa = this.formHandleParticipante.index_target || null;


                    if (this.formHandleParticipante.esCrear && this.validarRutDuplicadoSocio(new_socio.rut, new_socio.type, { parentIndex: parentIndexEmpresa })) {
                        EventBus.$emit('snack-error', 'Ya existe un socio con este RUT');
                        return;
                    }

                    if(this.formHandleParticipante.index_target !== null){
                        this.agregarParticipante(this.formHandleParticipante.index_target, new_socio);
                    }else{
                        //@ts-ignore
                        this.handleSocios(new_socio);
                    }
                    this.resetForm('formCreateEmpresa');
                    break;
                }
            }
        },
        createEmpresa(payload = {}){
            const socioEmpresa = {
                name: payload.razon_social || null,
                rut: payload.rut || null,
                pais: payload.pais || { id: '1', name: 'Chile' },
                participacion: payload.participacion || null,
                socios: payload.socios || [],
                PEP: '-',
                type: 'company',
                domicilio: '-',
                index: payload.index || 'socio_' + Math.random().toString(36).substr(2, 9),
                porcentajeGeneral: 100,
            };
            return socioEmpresa;
        },
        createPersona(payload = {}){
            const socioPersona = {
                nombres: payload.nombres || null,
                apellidos: payload.apellidos || null,
                name: payload.nombres + ' ' + payload.apellidos || null,
                rut: payload.rut || null,
                participacion: payload.participacion || null,
                pais: payload.pais || { id: '1', name: 'Chile' },
                domicilio: payload.domicilio || null,
                PEP: payload.pep || payload.PEP || null,
                type: 'person',
                index: payload.index || 'socio_' + Math.random().toString(36).substr(2, 9),
            }

            return socioPersona;
        },
        handleSocios(data){
            this.$data.socios = [...this.$data.socios, data];
        },
        async handleFunctionsTable(request){
            const { funcion, data } = request;

            const socio = await this.findParticipante(this.socios, data);
            this.resetForm(null);
            
            switch (funcion) {
                case 'addParticipante':
                    this.formHandleParticipante.empresa_target = socio.name;
                    this.formHandleParticipante.index_target = socio.index;
                    this.formHandleParticipante.porcentajeMax = socio.porcentajeGeneral;
                    this.modalHandleAddParticipante = true;
                    break;
                case 'deleteParticipante':
                    this.modalDeleteParticipante.socio_index = data;
                    this.modalDeleteParticipante.isCompany = socio.type === 'company' ? true : false;
                    this.modalDeleteParticipante.modal = true;
                    break;
                case 'editarParticipante':
                    this.handleEditParticipante(socio);
                    break;
                default:
                    break;
            }
        },
        findParticipante(array, index) {
            for (const item of array) {
                if (item.index === index) {
                    return item;
                }
                if (item.socios && item.socios.length > 0) {
                    const encontrado = this.findParticipante(item.socios, index);
                    if (encontrado) {
                        return encontrado;
                    }
                }
            }
            return null;
        },
        agregarParticipante(index, participante) {
            const item = this.findParticipante(this.socios, index);

            if (item.type === 'company') {
                this.socios = this.socios.reduce((acc, curr) => this.actualizarSociosReducer(acc, curr, index, participante), []);
            }
        },
        actualizarSociosReducer(acc, curr, index, nuevoParticipante) {
            if (curr.index === index && curr.type === 'company') {
                const nuevosSocios = curr.socios ? [...curr.socios, nuevoParticipante] : [nuevoParticipante];
                curr.porcentajeGeneral = 100 - this.calcPorcentaje(nuevosSocios);
                return [...acc, { ...curr, socios: nuevosSocios }];
            } else if (curr.socios) {
                return [...acc, { ...curr, socios: curr.socios.reduce((a, c) => this.actualizarSociosReducer(a, c, index, nuevoParticipante), []) }];
            }
            return [...acc, curr];
        },
        eliminarParticipante(index) {

            this.socios = this.socios.filter(socio => socio.index !== index);

            this.socios = this.socios.reduce((acc, curr) => this.eliminarSociosReducer(acc, curr, index), []);
            //reinicio de variables
            this.modalDeleteParticipante.modal = false;
            this.modalDeleteParticipante.isCompany = false;
            this.modalDeleteParticipante.socio_index = null;
            //recalcular el porcentaje
            this.$data.porcentajeGeneral = 100 - this.calcPorcentaje(this.socios);

        },
        eliminarSociosReducer(acc, curr, index) {
            if (curr.socios && curr.socios.some(socio => socio.index === index)) {
                const nuevosSocios = curr.socios.filter(socio => socio.index !== index);
                curr.porcentajeGeneral = 100 - this.calcPorcentaje(nuevosSocios);
                return [...acc, { ...curr, socios: nuevosSocios }];
            } else if (curr.socios) {
                return [...acc, { ...curr, socios: curr.socios.reduce((a, c) => this.eliminarSociosReducer(a, c, index), []) }];
            }

            return [...acc, curr];
        },
        resetForm(form = null){
            if(form !== null){
                this.$refs[form].reset();
            }else{
                if (this.$refs.formCreateEmpresa) {
                    this.$refs.formCreateEmpresa.reset();
                }

                if (this.$refs.formCreatePersona) {
                    this.$refs.formCreatePersona.reset();
                }
            }
            this.formHandleParticipante.esCrear = true;
            this.formHandleParticipante.empresa_target = null;
            this.formHandleParticipante.index_target = null;
            this.formHandleParticipante.check_boxes[0].checked = false;
            this.formHandleParticipante.check_boxes[1].checked = false;
            this.modalHandleAddParticipante = false;

            const porcentaje = this.calcPorcentaje(this.socios);
            this.formHandleParticipante.porcentajeMax = 100 - porcentaje;
        },
        handleEditParticipante(participante){
            this.resetForm();

            this.formHandleParticipante.esCrear = false;
            this.formHandleParticipante.index_target = participante.index;

            // definicion de validacion de porcentaje maximo
            const porcentaje = participante.index == participante.parentIndex ? this.porcentajeGeneral : this.findParticipante(this.socios, participante.parentIndex).porcentajeGeneral;
            this.formHandleParticipante.porcentajeMax = Math.abs(parseInt(porcentaje) - parseInt(participante.participacion)) == 0 ? 100 :  Math.abs(parseInt(porcentaje) + parseInt(participante.participacion));

            if(participante.type === 'person'){
                this.formHandleParticipante.check_boxes[0].checked = true;
                
                this.$nextTick(() => {
                    this.formPersona = {
                        nombres: participante.nombres,
                        apellidos: participante.apellidos,
                        rut: participante.rut,
                        participacion: participante.participacion.toString(),
                        pais: participante.pais,
                        domicilio: participante.domicilio,
                        pep: participante.PEP
                    };
                });
            }
            else{
                this.formHandleParticipante.check_boxes[1].checked = true;
                this.$nextTick(() => {
                    this.formEmpresa = {
                        razon_social: participante.name,
                        rut: participante.rut,
                        participacion: participante.participacion.toString(),
                        pais: participante.pais
                    };
                });
            }
            
            this.modalHandleAddParticipante = true;
        },
        updateParticipante(array, index, newProps) {
            return array.map(item => {
                if (item.index === index) {
                    return {
                        ...item,
                        ...newProps
                    };
                } else if (item.socios && item.socios.length > 0) {
                    return {
                        ...item,
                        socios: this.updateParticipante(item.socios, index, newProps)
                    };
                }
                return item;
            });
        },
        submitEdit(){
            const index = this.formHandleParticipante.index_target;
            const socio = this.findParticipante(this.socios, index.trim());

            if(socio.type === 'company'){
                const newProps = {
                    name: this.formEmpresa.razon_social,
                    rut: this.formEmpresa.rut,
                    participacion: this.formEmpresa.participacion,
                    pais: this.formEmpresa.pais,
                };

                const parentIndex = socio.index === socio.parentIndex ? null : socio.parentIndex;
                const esDuplicado = this.validarRutDuplicadoSocio(
                    newProps.rut,
                    socio.type,
                    { parentIndex, ignoreIndex: socio.index }
                );

                if (esDuplicado) {
                    EventBus.$emit('snack-error', 'Ya existe un socio con este RUT');
                    return;
                }
                
                this.socios = this.updateParticipante(this.socios, socio.index, newProps);
                this.resetForm('formCreateEmpresa');

            }else{
                const newProps = {
                    nombres: this.formPersona.nombres,
                    apellidos: this.formPersona.apellidos,
                    name: this.formPersona.nombres + ' ' + this.formPersona.apellidos,
                    rut: this.formPersona.rut,
                    participacion: this.formPersona.participacion,
                    pais: this.formPersona.pais,
                    domicilio: this.formPersona.domicilio,
                    PEP: this.formPersona.pep
                };

                const parentIndex = socio.index === socio.parentIndex ? null : socio.parentIndex;
                const esDuplicado = this.validarRutDuplicadoSocio(
                    newProps.rut,
                    socio.type,
                    { parentIndex, ignoreIndex: socio.index }
                );

                if (esDuplicado) {
                    EventBus.$emit('snack-error', 'Ya existe un socio con este RUT');
                    return;
                }

                
                this.socios = this.updateParticipante(this.socios, socio.index, newProps);
                this.resetForm('formCreatePersona');

                if(socio.index !== socio.parentIndex){
                    this.updatePorcentaje(socio.parentIndex);
                }
            }

        },
        validarSocio(socio){
            if(socio.type === 'company'){
                return this.validarSocioEmpresa(socio);

            }else{
                return this.validarSocioPersona(socio);
            }
        },
        validarSocioPersona(socio){
            const { nombres, apellidos, pais, participacion, rut, PEP, domicilio  } = socio;

            if( this.evaluarValor(nombres) && 
                this.evaluarValor(apellidos) &&
                this.evaluarValor(pais) &&
                this.evaluarValor(participacion) &&
                this.evaluarValor(rut) &&
                this.evaluarValor(PEP) &&
                this.evaluarValor(domicilio) 
            ){
                return true;
            }
            return false;      
        },
        validarSocioEmpresa(socio){
            const { name, pais, participacion, rut, socios  } = socio;

            // Array.isArray: un socio empresa cargado desde data_form_guardada o del scraper puede
            // llegar sin la clave `socios` (createEmpresa siempre la inicializa, otros caminos no).
            // Sin este guard, `socios.length` lanzaba TypeError y reventaba el computed canContinue,
            // impidiendo incluso que se mostrara el mensaje de campos faltantes.
            if( this.evaluarValor(name) &&
                this.evaluarValor(pais) &&
                this.evaluarValor(participacion) &&
                this.evaluarValor(rut) &&
                Array.isArray(socios) &&
                socios.length > 0 &&
                100 - this.calcPorcentaje(socios) == 0
            ){
                return true;
            }

            return false;
        },
        evaluarValor(value) {
            return value !== null && value !== '';
        },
        calcPorcentaje(arr){
            const sumPorcentaje = arr.reduce((acc, item) => {
                return acc + parseFloat(item.participacion)
            }, 0);
            return sumPorcentaje;
        },
        async apiCallSocios(natural = false, data_p = {}){
            const response = await api.obtenerSocios(this.$data.empresa_id);
            const { data: { data }, status } = response;

            if(status == 200){
                const socios = this.limpiarDuplicados(data, new Set());
                if(socios.length > 0){
                    socios.forEach((socio) => {
                        const { nombres, a_paterno, a_materno, rut, rut_dv, razon_social, participacion} = socio;
                        const rut_parser = rutParser(rut.toString() + rut_dv.toString());
                        const esPersonaNatural = razon_social == 'None';

                        if(!esPersonaNatural){
                            const nuevo_socio = {
                                razon_social,
                                rut: rut_parser,
                                participacion,  
                            }
                            
                            this.handleSocios(this.createEmpresa(nuevo_socio));
                        }else{
                            const nuevo_socio = {
                                nombres, 
                                apellidos: a_paterno + " " + (a_materno == 'None' ? '' : a_materno),
                                rut: rut_parser,
                                participacion,
                            }
                            this.handleSocios(this.createPersona(nuevo_socio));
                        }

                    });
                    this.$data.canShow = true;
                }
                else if(natural){
                    const { nombre, rut } = data_p;
                    const nombre_completo = nombre.split(" ");
                    let nombres = '';
                    let app = '';
                    
                    if(nombre_completo.length == 4){
                        nombres = `${nombre_completo[0]} ${nombre_completo[1]}`;
                        app = `${nombre_completo[2]} ${nombre_completo[3]}`;
                    }
                    const rut_parser = rutParser(rut);
                    
                    const nuevo_socio = {
                        nombres, 
                        apellidos: app,
                        rut: rut_parser,
                        participacion: 100,
                    }

                    this.handleSocios(this.createPersona(nuevo_socio));
                    this.$data.canShow = true;
                }
                else{
                    this.$data.canShow = true;
                }
            }else{
                this.$data.canShow = true;
            }
        },
        createPayload() {
            const { socios } = this.$data;
            let payload = {};

            if (socios.length > 0) {
                payload.socios = socios.map(socio => {
                    if (socio.type === 'company') {
                        return {
                            razon_social: socio.name,
                            rut: socio.rut,
                            pais: socio.pais,
                            participacion: socio.participacion,
                            PEP: socio.PEP,
                            type: socio.type,
                            domicilio: socio.domicilio,
                            index: socio.index,
                            porcentajeGeneral: socio.porcentajeGeneral,
                            socios: socio.socios.map(subSocio => {
                                return this.formatSubSocio(subSocio);
                            })
                        };
                    } else {
                        return {
                            nombres: socio.nombres,
                            apellidos: socio.apellidos,
                            rut: socio.rut,
                            participacion: socio.participacion,
                            pais: socio.pais,
                            domicilio: socio.domicilio,
                            PEP: socio.PEP,
                            type: socio.type,
                            index: socio.index,
                        };
                    }
                });
            }

            return payload;
        },

        formatSubSocio(subSocio) {
            if (subSocio.type === 'company') {
                return {
                    name: subSocio.name,
                    rut: subSocio.rut,
                    pais: subSocio.pais,
                    participacion: subSocio.participacion,
                    PEP: subSocio.PEP,
                    type: subSocio.type,
                    domicilio: subSocio.domicilio,
                    index: subSocio.index,
                    porcentajeGeneral: subSocio.porcentajeGeneral,
                    socios: subSocio.socios.map(nestedSubSocio => {
                        return this.formatSubSocio(nestedSubSocio);
                    })
                };
            } else if (subSocio.type === 'person') {
                return {
                    nombres: subSocio.nombres,
                    apellidos: subSocio.apellidos,
                    name: subSocio.nombres + ' ' + subSocio.apellidos,
                    rut: subSocio.rut,
                    participacion: subSocio.participacion,
                    pais: subSocio.pais,
                    domicilio: subSocio.domicilio,
                    PEP: subSocio.PEP,
                    type: subSocio.type,
                    index: subSocio.index,
                };
            }
        },
        handleDataSocios(socios){
            try {
                const socios_data = JSON.parse(socios.valor);
                const repetido = new Set();

                socios_data.forEach((socio) => {
                    const key = `${socio.rut}-${socio.type}`;
                    
                    if(repetido.has(key)) return;
                    repetido.add(key);

                    if(socio.type === 'company'){
                        this.handleSocios(this.createEmpresa(socio));
                    }else{
                        this.handleSocios(this.createPersona(socio));
                    }
                });
                this.$data.canShow = true;
            } catch (error) {
                //@ts-ignore
                this.apiCallSocios();
            }
        },
        updatePorcentaje(parentIndex){
            const socio = this.findParticipante(this.socios, parentIndex);
            
            const sumPorcentaje = socio.socios.reduce((acc, item) => {
                return acc + parseFloat(item.participacion)
            }, 0);

            socio.porcentajeGeneral = 100 - sumPorcentaje;
        },
        validarRutDuplicadoSocio(rut, type = 'person', options = {}) {
            const { parentIndex = null, ignoreIndex = null } = options;

            const checkLevel = (arr) => {
                return arr.some((socio) => {
                    if (ignoreIndex && socio.index === ignoreIndex) {
                        return false;
                    }

                    return socio.rut === rut && socio.type === type;
                });
            };

            if (!parentIndex) {
                return checkLevel(this.socios);
            }

            const parent = this.findParticipante(this.socios, parentIndex);

            if (!parent || !parent.socios || !parent.socios.length) {
                return false;
            }

            return checkLevel(parent.socios);
        },
        limpiarDuplicados(arr, setGlobal){
            const result = [];

            arr.forEach((socio) => {
                const key = `${socio.rut}-${socio.type}`;
                if (setGlobal.has(key)) return;

                setGlobal.add(key);

                const limpio = { ...socio };
                if (limpio.socios && limpio.socios.length) {
                    limpio.socios = limpiarDuplicados(limpio.socios, setGlobal);
                }
                result.push(limpio);
            });

            return result;
        },

    },
    components: {
        TableInfo2Vue,
        ShowLoading
    }
})

export default class Step2BCIForm extends Vue {}
</script>

<style lang="scss" scoped>
	/* Identificacion de la empresa bajo el titulo del paso */
	.rc-empresa-actual {
		margin-top: 2px;
		font-size: 14px;
		font-weight: 400;
		color: var(--theme-text-muted);
	}

    .btn_close{
		position: absolute !important;
		right: 0;
		border-radius: 25px;
		padding: 11px;
		display: flex;
		justify-content: center;
		align-items: center;
		min-width: 36px;
	}
    .info__card {
		border: 1px solid #FAD9D4; 
		border-radius: 10px; 
		padding:10px;
		display: flex; 
		flex-direction: row; 
		justify-content: flex-start; 
		align-items: center; 
		gap: 10px; 
		background-color: #FAD9D4;
	}

	.text__card{
		font-weight: 400;
		font-size: 13px;
		text-align: left;
	}

	/* RC-3727: ajustes globales según diseño Figma "Socios participantes - sin data" */

	/* Tipografía base del formulario: SF Pro Text Regular 14px (Figma) con fallbacks */
	::v-deep .card__form,
	::v-deep .content__head,
	::v-deep .libro-card,
	::v-deep .card__form *,
	::v-deep .content__head *,
	::v-deep .libro-card * {
		font-family: 'SF Pro Text', -apple-system, BlinkMacSystemFont, 'Segoe UI', Helvetica, Arial, sans-serif !important;
		letter-spacing: 0 !important;
	}
	::v-deep .card__form,
	::v-deep .libro-card {
		font-weight: 400;
		font-size: 14px;
		line-height: 1;
	}

	/* Restaurar font-family de íconos (el override anterior los rompía) */
	::v-deep .v-icon,
	::v-deep i.material-icons,
	::v-deep .material-icons {
		font-family: 'Material Icons' !important;
	}
	::v-deep i.material-icons-outlined,
	::v-deep .material-icons-outlined {
		font-family: 'Material Icons Outlined' !important;
	}
	::v-deep .material-icons-round {
		font-family: 'Material Icons Round' !important;
	}
	::v-deep .material-symbols-outlined {
		font-family: 'Material Symbols Outlined' !important;
	}

	/* Card principal: ancho fijo (~920px) según diseño Figma */
	::v-deep .card__form {
		max-width: 1200px !important;
		width: 100% !important;
		box-shadow: 0px 4px 44px #00000026 !important;
	}
	::v-deep .content__head {
		max-width: 1200px !important;
		width: 100% !important;
	}

	/* Headers de la tabla (v-data-table de Vuetify 1.5) estilo Figma */
	::v-deep .v-datatable {
		box-shadow: none !important;
		background: transparent !important;
	}
	::v-deep .v-datatable thead tr {
		height: auto !important;
		background-color: #f3f3f3 !important;
		border-bottom: none !important;
	}
	::v-deep .v-datatable thead th {
		background-color: #f3f3f3 !important;
		color: var(--theme-text) !important;
		font-weight: 600 !important;
		font-size: 14px !important;
		padding: 10px !important;
		height: auto !important;
		border: none !important;
		text-align: left !important;
	}
	::v-deep .v-datatable thead th > div {
		justify-content: flex-start !important;
	}
	::v-deep .v-datatable thead th:first-child {
		border-top-left-radius: 4px;
		border-bottom-left-radius: 4px;
	}
	::v-deep .v-datatable thead th:last-child {
		border-top-right-radius: 4px;
		border-bottom-right-radius: 4px;
	}

	/* Body: filas sin fondo y sin separación entre ellas (pegadas) */
	::v-deep .v-datatable tbody tr {
		height: auto !important;
		background-color: transparent !important;
		border: none !important;
	}
	::v-deep .v-datatable tbody tr:hover {
		background-color: transparent !important;
	}
	::v-deep .v-datatable tbody td {
		color: var(--theme-text) !important;
		font-size: 14px !important;
		font-weight: 400 !important;
		padding: 10px !important;
		border: none !important;
		text-align: left !important;
		vertical-align: middle !important;
		height: auto !important;
		background-color: transparent !important;
	}
	::v-deep .v-datatable {
		border-spacing: 0 !important;
		border-collapse: collapse !important;
	}
	::v-deep .v-datatable tbody td > div {
		text-align: left !important;
		justify-content: flex-start !important;
	}

	/* Última fila: bordes inferiores redondeados 4px */
	::v-deep .v-datatable tbody tr:last-child td:first-child {
		border-bottom-left-radius: 4px;
	}
	::v-deep .v-datatable tbody tr:last-child td:last-child {
		border-bottom-right-radius: 4px;
	}

	/* Botones de acción en celda final agrupados en línea, íconos naranjas */
	::v-deep .v-datatable tbody td .rc-btnTable {
		margin: 0 2px !important;
		min-width: 24px !important;
		height: 24px !important;
		width: 24px !important;
	}
	::v-deep .v-datatable tbody td .rc-btnTable .material-icons-outlined,
	::v-deep .v-datatable tbody td .rc-btnTable .material-icons {
		font-size: 20px !important;
		color: var(--theme-primary) !important;
	}
	::v-deep .v-datatable tbody td .rc-btnTable:disabled .material-icons-outlined,
	::v-deep .v-datatable tbody td .rc-btnTable:disabled .material-icons {
		color: #d9d9d9 !important;
	}
	::v-deep .v-datatable tbody td .rc-btnTable.btn__toggle-expand .material-icons-outlined,
	::v-deep .v-datatable tbody td .rc-btnTable.btn__toggle-expand .material-icons {
		color: #000000 !important;
	}

	/* Row vacío "No existen registros" centrado con fondo blanco */
	::v-deep .v-datatable tbody tr td.text-xs-center {
		text-align: center !important;
		color: var(--theme-text) !important;
		font-size: 14px !important;
		padding: 10px !important;
		background-color: #ffffff !important;
		border-bottom: none !important;
	}

	/* Rows de expand de Vuetify: sin bordes ni fondo para evitar franjas visuales */
	::v-deep .v-datatable tbody tr.v-datatable__expand-row {
		background-color: transparent !important;
		border: none !important;
	}
	::v-deep .v-datatable tbody tr.v-datatable__progress {
		display: none !important;
	}
	::v-deep .v-datatable tbody tr td.v-datatable__expand-col {
		padding: 0 !important;
		border: none !important;
		background: transparent !important;
	}

	/* Quitar borde y fondo del footer paginación */
	::v-deep .v-datatable__actions {
		background-color: transparent !important;
		border-top: none !important;
	}

	/* Sangría visual para filas de subsocios (expanded rows) */
	::v-deep .v-datatable tbody tr.expanded__row + tr td:first-child,
	::v-deep .v-datatable .v-card tbody td:first-child {
		padding-left: 24px !important;
	}

	/* RC-3727: subtítulo con tooltips (Figma: 18px regular, var(--theme-text)) */
	.rc-subtitulo-socios {
		font-size: 18px;
		color: var(--theme-text);
		font-weight: 400;
		line-height: 1.5;
		display: flex;
		flex-wrap: wrap;
		align-items: center;
		gap: 4px;
	}
	.rc-tooltip-anchor {
		display: inline-flex;
		align-items: center;
		gap: 2px;
		white-space: nowrap;
	}
	.rc-tooltip-icon {
		cursor: help;
		vertical-align: middle;
	}

	/* RC-3727: card del libro de accionistas (Figma: border-radius 5px, padding 16px, border #cecece) */
	.libro-card {
		border: 1px solid #cecece;
		border-radius: 5px;
		padding: 16px;
		background: #ffffff;
		display: flex;
		flex-direction: column;
		gap: 14px;
	}
	.libro-card__title {
		font-size: 18px;
		font-weight: 600;
		color: var(--theme-text);
		margin: 0;
	}
	.libro-card__subtitle {
		font-size: 14px;
		font-weight: 600;
		color: var(--theme-text);
		margin: 0;
	}

	/* RC-3727: dropzone inline (Figma: border 1px dashed var(--theme-text-muted), border-radius 20px, padding 24px) */
	.libro-dropzone {
		border: 1px dashed var(--theme-text-muted);
		border-radius: 20px;
		padding: 24px;
		background: #ffffff;
		cursor: pointer;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		gap: 4px;
		transition: background 0.15s ease, border-color 0.15s ease;
		overflow: hidden;
	}
	.libro-dropzone--dragging {
		background: var(--theme-primary-tint);
		border-color: var(--theme-primary);
	}
	.libro-dropzone--has-file {
		cursor: default;
	}
	.libro-dropzone__hint {
		font-size: 16px;
		font-weight: 600;
		color: var(--theme-text);
		line-height: 21px;
		text-align: center;
		width: 100%;
	}
	.libro-dropzone__icon {
		width: 44px;
		height: 44px;
		color: var(--theme-primary);
		display: block;
	}
	.libro-dropzone__link {
		font-size: 14px;
		font-weight: 400;
		color: var(--theme-primary);
		text-decoration: underline;
		line-height: 21px;
		cursor: pointer;
		text-align: center;
	}
	.libro-dropzone__link:hover {
		color: var(--theme-primary);
	}
	.libro-dropzone__meta {
		font-size: 12px;
		color: var(--theme-text-muted);
		line-height: 21px;
		text-align: center;
	}
	/* RC-3727: card de archivo seleccionado */
	.libro-file-card {
		border: 1px solid #cecece;
		border-radius: 8px;
		padding: 12px 16px;
		background: #ffffff;
		display: flex;
		flex-direction: column;
		gap: 10px;
	}
	.libro-file-card__body {
		display: flex;
		align-items: center;
		gap: 12px;
	}
	.libro-file-card__icon {
		width: 36px;
		height: 36px;
		flex-shrink: 0;
		color: var(--theme-text-muted);
	}
	.libro-file-card__info {
		flex: 1;
		min-width: 0;
	}
	.libro-file-card__name {
		font-size: 14px;
		font-weight: 600;
		color: var(--theme-text);
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}
	.libro-file-card__size,
	.libro-file-card__progress-text {
		font-size: 12px;
		color: var(--theme-text-muted);
		margin-top: 2px;
	}
	.libro-file-card__percent {
		font-size: 14px;
		color: var(--theme-text);
		flex-shrink: 0;
		margin-right: 4px;
	}
	.libro-file-card__remove {
		flex-shrink: 0;
	}
	.libro-file-card__bar {
		width: 100%;
		height: 4px;
		background: #e0e0e0;
		border-radius: 2px;
		overflow: hidden;
	}
	.libro-file-card__bar-fill {
		height: 100%;
		background: var(--theme-primary);
		border-radius: 2px;
		transition: width 0.2s ease;
	}
	.libro-eliminar-btn {
		color: var(--theme-danger) !important;
		font-size: 13px !important;
		font-weight: 500 !important;
		text-transform: none !important;
		padding: 0 8px !important;
		min-width: unset !important;
		height: 28px !important;
	}
	.libro-replace-wrap {
		margin-top: 10px;
	}
	.libro-replace-btn {
		color: var(--theme-primary) !important;
		border-color: var(--theme-primary) !important;
		font-size: 13px !important;
		font-weight: 500 !important;
		text-transform: none !important;
		border-radius: 20px !important;
		height: 32px !important;
	}
	/* Estado de error */
	.libro-error-card {
		border: 1px solid var(--theme-danger);
		border-radius: 8px;
		padding: 12px 16px;
		background: #FFF5F5;
	}
	.libro-error-card__body {
		display: flex;
		align-items: center;
	}
	.libro-error-msg {
		font-size: 13px;
		color: var(--theme-danger);
		margin-top: 8px;
	}
	.libro-select-otro-btn {
		background-color: var(--theme-primary) !important;
		color: var(--theme-on-primary) !important;
		font-size: 13px !important;
		font-weight: 500 !important;
		text-transform: none !important;
		border-radius: 20px !important;
		height: 34px !important;
		padding: 0 18px !important;
	}
	.alerta-tradicional__text {
		color: var(--theme-text) !important;
		font-size: 15px;
	}

</style>
